import './_accordion.scss';

$(() => {
    if (!$('.accordion__toggle').length) {
        return;
    }
    $('.accordion__toggle').on('click', (el) => {
        const $target = $(el.target);
        const $accordion = $target.closest('.accordion');
        $accordion.toggleClass('expanded');
        const isExpanded = $accordion.hasClass('expanded') ? 'true' : 'false';
        $target.attr('aria-expanded', isExpanded);
    });
});
